import { useSelector } from 'react-redux';
import { FrontofficeBannerGetListPositionsItem } from 'generated/api/frontofficeAPI.schemas';

import type { WithTestId } from 'types/app';

import { selectBannersByPosition } from '@Modules/banners/selectors';

import { BannerByPosition } from '@Atomic/molecules/BannerByPosition';
import { VeonAdBanner } from '@Atomic/molecules/VeonAdBanner';

const POSITION = FrontofficeBannerGetListPositionsItem.WEB_RIGHT_OFFER_CARD;

export type OfferCardBannerProps = WithTestId<{
  className?: string;
}>;

/**
 * Offer-card banner slot. Renders an admin-configured banner for the position
 * when the backend returned one, otherwise falls back to a Veon Adtech banner.
 */
export const OfferCardBanner = ({ className, testId }: OfferCardBannerProps) => {
  const banners = useSelector(selectBannersByPosition(POSITION));

  if (banners.length > 0) {
    return <BannerByPosition position={POSITION} className={className} testId={testId} />;
  }

  return <VeonAdBanner className={className} testId={testId} />;
};
